
import { SpinePlayer } from '../../../core/displayobject/SpinePlayer';
import { Helper } from '../../../core/utils/Helper';

export class SanSpineBox extends PIXI.Container {

    public spine: SpinePlayer;

    constructor(path:string, txt?:string) {
        super();
        this.spine = this.addChild(new SpinePlayer(path));
    }

    playShow(durr:number = 0.25){
        this.spine.play({ animation: "animation", freezed: true });
        this.spine.visible = true;
        const tl = Helper.setTimeline();
        
        tl.fromTo(this, { alpha: 0 }, { alpha: 1, duration: durr }, 0);
        tl.fromTo(this.scale, { x: 1.25, y: 1.25*0.8 }, { x: 1, y: 0.8, duration: durr }, 0);
        
        return tl;
    }

    playExplode(){
        return this.spine.play({animation:"animation",showOnEnd:true});
    }
}
